import * as Sentry from '@sentry/react';

import { WorkspaceNotInitializedError } from '@/error-handler/WorkspaceNotInitializedError';

declare const __SENTRY_RELEASE__: string;

const getSentryEnvironment = () => {
  const env = import.meta.env.VITE_PUBLIC_ENVIRONMENT;
  if (env === 'dev') return 'staging';
  if (env === 'prod') return 'production';
  return 'local';
};

const environment = getSentryEnvironment();

Sentry.init({
  dsn: 'https://8be43d51778059545767f3cdccb4c4b5@o4509438014521344.ingest.us.sentry.io/4510713255428096',
  sendDefaultPii: true,
  environment,
  release: __SENTRY_RELEASE__,
  enabled: environment !== 'local',
  beforeSend(event, hint) {
    const error = hint?.originalException;

    // 워크스페이스 전환 시 예상되는 에러 → Sentry 전송 차단
    if (error instanceof WorkspaceNotInitializedError) {
      return null;
    }

    // 레거시 string throw 방어 (배포 과도기 대응)
    if (typeof error === 'string' && error === 'Workspace not initialized') {
      return null;
    }

    return event;
  },
});
